var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card-item", class: { noDoubleShadow: !_vm.hasSiblings } },
    [
      _c(
        "div",
        {
          staticClass: "fee-item-info clearfix",
          class: {
            client: _vm.currentUserIsClient,
            client: !_vm.collectClientDebt,
          },
        },
        [
          _vm.currentUserIsClient || !_vm.collectClientDebt
            ? _c(
                "div",
                { staticClass: "fee-item-select" },
                [
                  _vm.isPaymentLoading
                    ? _c("div", { staticClass: "round-choice-transparent" }, [
                        _c("span", {
                          staticClass:
                            "content-title fas fa-lg fa-spinner fa-spin",
                        }),
                      ])
                    : [
                        !_vm.payment.isPending
                          ? _c("div", { staticClass: "round-choice-content" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.isChecked,
                                    expression: "isChecked",
                                  },
                                ],
                                staticClass: "input-choice",
                                attrs: {
                                  id: `checkbox-${_vm.payment.operationId}-${_vm.payment.paymentNumber}`,
                                  type: "checkbox",
                                  disabled: _vm.disabled,
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.isChecked)
                                    ? _vm._i(_vm.isChecked, null) > -1
                                    : _vm.isChecked,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.confirmCheck.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                  change: function ($event) {
                                    var $$a = _vm.isChecked,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.isChecked = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.isChecked = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.isChecked = $$c
                                    }
                                  },
                                },
                              }),
                              _c("label", {
                                staticClass: "label-choice transition-fast",
                                attrs: {
                                  for: `checkbox-${_vm.payment.operationId}-${_vm.payment.paymentNumber}`,
                                },
                              }),
                            ])
                          : _c(
                              "div",
                              [
                                _c(
                                  "b-tooltip",
                                  {
                                    attrs: {
                                      type: "is-white",
                                      label: "Pago en revisión",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "round-choice-content payment-is-pending",
                                      },
                                      [
                                        _c("input", {
                                          staticClass: "input-choice",
                                          attrs: {
                                            id: `checkbox-${_vm.payment.operationId}-${_vm.payment.paymentNumber}`,
                                            type: "checkbox",
                                            disabled: true,
                                          },
                                          domProps: { checked: true },
                                        }),
                                        _c("label", {
                                          staticClass:
                                            "label-choice transition-fast",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                      ],
                ],
                2
              )
            : _vm._e(),
          _c("div", { staticClass: "fee-item-resume-content" }, [
            _c(
              "div",
              { staticClass: "type-content" },
              [
                _c(
                  "b-tooltip",
                  {
                    attrs: {
                      label: `${_vm.$t("credit")} ${_vm.$t(
                        _vm.type.toLowerCase()
                      )}`,
                      size: "is-small",
                      type: "is-white",
                      multilined: "",
                    },
                  },
                  [
                    _vm.type === "MORTGAGE"
                      ? _c("span", [_vm._v("🏡")])
                      : _vm._e(),
                    _vm.type === "COMPLEMENTARY"
                      ? _c("span", [_vm._v("💰")])
                      : _vm._e(),
                    _vm.type === "SME" ? _c("span", [_vm._v("🚀")]) : _vm._e(),
                    _vm.type === "PARKING"
                      ? _c("span", [_vm._v("🅿️")])
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "price-content" }, [
              !_vm.showAmount && !_vm.disabled
                ? _c("div", { staticClass: "show-fee-label big-size-text" }, [
                    _c(
                      "label",
                      {
                        staticClass: "is-clickable content-title",
                        attrs: {
                          for: `checkbox-${_vm.payment.operationId}-${_vm.payment.paymentNumber}`,
                        },
                      },
                      [_c("span", [_vm._v("Ver cuota")])]
                    ),
                  ])
                : (_vm.showAmount && !_vm.disabled) ||
                  _vm.checked ||
                  _vm.payment.isPending
                ? _c("div", { staticClass: "big-size-text" }, [
                    _c(
                      "span",
                      {
                        staticClass: "content-title",
                        attrs: {
                          id: `${_vm.payment.operationId}-${_vm.payment.paymentNumber}-amount`,
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              `${
                                _vm.$i18n.locale === "cl"
                                  ? "$"
                                  : _vm.monetarySign
                              } ${_vm.formatNumber(
                                _vm.payment
                                  .secondaryCurrencyTotalMonthlyPayment ||
                                  _vm.payment.totalMonthlyPayment
                              )}`
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ])
                : _c("div"),
            ]),
            !_vm.hasSiblings
              ? _c("div", { staticClass: "duration-content med-size-text" }, [
                  _c("div", [
                    _c("span", { staticClass: "content-title" }, [
                      _vm._v(_vm._s(_vm.$t("fee"))),
                    ]),
                    _c("span", { staticClass: "content-value" }, [
                      _vm._v(_vm._s(_vm.payment.paymentNumber)),
                      !_vm.currentUserIsClient &&
                      !_vm.hasSiblings &&
                      _vm.collectClientDebt
                        ? _c("span", [
                            _vm._v(" de " + _vm._s(_vm.operation.termAsMonths)),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _c("div", [
                    _c(
                      "span",
                      {
                        class:
                          _vm.payment.lateDays > 0
                            ? "alert-content-title"
                            : "content-title",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.payment.lateDays > 0
                                ? _vm.$t("expired")
                                : _vm.$t("expires")
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c("span", { staticClass: "content-value" }, [
                      _vm._v(
                        _vm._s(_vm.dateToClientFormat(_vm.payment.dueDate))
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            !_vm.currentUserIsClient &&
            !_vm.hasSiblings &&
            _vm.collectClientDebt
              ? _c(
                  "div",
                  { staticClass: "late-days-content med-size-text" },
                  [
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          label: `${_vm.$t("lateDays")}`,
                          type: "is-white",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "tag med-size-text is-danger",
                            class:
                              _vm.payment.lateDays >= 90
                                ? "ninety-days"
                                : _vm.payment.lateDays >= 60
                                ? "sixty-days"
                                : _vm.payment.lateDays >= 30
                                ? "thirty-days"
                                : _vm.payment.lateDays >= 11
                                ? "less-than-thirty-days"
                                : "healthy-days",
                          },
                          [_vm._v(" " + _vm._s(_vm.payment.lateDays) + " ")]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm.showAmount
            ? _c("div", { staticClass: "details-content" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      id: `extend-${_vm.payment.operationId}-${_vm.payment.paymentNumber}`,
                      href: "#",
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.$emit("extend-payment")
                      },
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "fa",
                      class: _vm.isExtended
                        ? "fa-minus-circle"
                        : "fa-plus-circle",
                    }),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
      _c("SinglePaymentDetails", {
        attrs: {
          "is-extended": _vm.isExtended,
          "show-remove-late-charges": _vm.showRemoveLateCharges,
          payment: _vm.payment,
          operation: _vm.operation,
          type: _vm.type,
          "monetary-sign": _vm.monetarySign,
        },
        on: {
          "remove-late-charges": function ($event) {
            return _vm.$emit("remove-late-charges", $event)
          },
          "undo-remove-late-charges": function ($event) {
            return _vm.$emit("undo-remove-late-charges", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }